<template>
  <div class="forgotpassword">
    <div class="navbar">
      <div class="logo">
        <img src="../../assets/imgs/MES-LOGO.png" alt />
      </div>
    </div>
    <div class="center">
      <h1>Forgot password</h1>
      <el-form
        :model="forgotForm"
        status-icon
        ref="forgotForm"
        label-width="100px"
        class="demo-ChangeForm"
      >
        <el-form-item id="email" prop="email">
          <el-input v-model="forgotForm.userMail" placeholder="Your Email"></el-input>
        </el-form-item>
        <el-button @click="submitForm('forgotForm')">Next</el-button>
      </el-form>
      <el-link
        @click="$router.push('/login')"
        :underline="false"
        target="_blank"
        class="login"
      >Login</el-link>
    </div>
    <div class="footer"> Copyright © csvip.club<img src="../../assets/imgs/beian.png" alt=""> <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2020126125号</a></div>
  </div>
</template>

<script>
//导入axios
import { apiForgotPass } from "../../api/userInfo";
//导入抽取的token方法
export default {
  name: "forgotpassword",
  data() {
    // 邮箱验证规则
    // var checkEmail = (rule, value, callback) => {
    //   if (value === "") {
    //     callback(new Error("The mailbox cannot be empty"));
    //   } else {
    //     const reg = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
    //     setTimeout(() => {
    //       if (!reg.test(value)) {
    //         callback(new Error("Incorrect mailbox format"));
    //       } else {
    //         callback();
    //       }
    //     }, 1000);
    //   }
    // };
    return {
      forgotForm: {
        userMail: "",
      },
      // rules: {
      //   email: [{ required: true, validator: checkEmail, trigger: "blur" }],
      // },
    };
  },

  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //对邮箱进行非空判断
          if (this.forgotForm.userMail.trim() == "") {
            this.$message.warning("The email cannot be empty");
            return;
          }

          //对勾选框进行勾选判断
          apiForgotPass({
            userMail: this.forgotForm.userMail,
          }).then((res) => {
            console.log(res);
            if (res.data.code === 200) {
              //登录成功
              this.$message.success(res.data.message);
              //系统有该邮箱,跳转到改变密码页
            } else {
              //跳转到这里说明邮箱未注册 跳转到注册页
              this.$message.error(res.data.message);
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.forgotpassword {
  min-height: calc(100vh);
  width: 100%;
  overflow: hidden;
  background-color: #f2f2f2;
  height: 394px;

  .navbar {
    height: 55px;
    min-width: 1366px;
    background-color: #fff;
    border-bottom: 1px solid #c8ced3;
    margin: 0 auto;
    overflow: hidden;
    .logo {
      width: 162px;
      height: 40px;
      margin-top: 0px;
      float: left;
      img {
        width: 100%;
      }
    }
  }
  .center {
    height: 289px;
    width: 590px;
    background-color: #fbfbfb;
    margin: 0 auto;
    margin-top: 52px;
    padding: 30px 43px 50px;
    box-sizing: border-box;

    h1 {
      text-align: center;
      color: #333333;
      margin-bottom: 35px;
    }

    .el-input {
      width: 320px;
      position: relative;

      .el-input__inner {
        background-color: #f2f2f2;
        background-image: none;
        border-radius: 0;
        border: 1px solid #cccccc;
      }

      i.el-input__icon.iconfont.icon-xianshi {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 9999;
      }
    }
    .el-button {
      border-radius: 0;
      width: 322px;
      margin-left: 100px;
      background-color: #00b0a6;
      color: white;
      border: none;
      margin-bottom: 30px;
      font-size: 16px;
    }
    .login {
      color: #00b0a6;
      text-align: center;
      height: 20px;
      width: 40px;
      overflow: hidden;
      background-color: #fbfbfb;
      margin-left: 243px;
    }
    .el-link.el-link--default:hover {
      color: #00afa6;
    }
  }
}
.footer{
    position: absolute;
    left: 40%;
    bottom: 20px;
    text-align: center;
    // background-color: rgb(84, 92, 100);
    color: 	#0A0A0A;
    height: 50px;
    line-height: 50px;
    img{
      margin: 0px 6px;
    }
    a{
       color: #337ab7;
    }
}
</style>